module.exports = __webpack_public_path__ + "img/1.5cb7e94b.jpg";